import { gql } from '@apollo/client';
import { EntityCategoryFragment } from '../entityCategories';
import { RelationalOperatorFragment } from '../fragments';

const NestedFieldMetadataFields = gql`
  fragment NestedFieldMetadataFields on NestedFieldMetadata {
    type
    name
    fieldKey
    key
  }
`;

export const BasicFieldValueFragment = gql`
  fragment BasicFieldValueFields on BasicFieldValue {
    key
    name
    isDisabled
    description
  }
`;

export const AnyFieldValueFragment = gql`
  fragment AnyFieldValueFields on AnyFieldValue {
    name
  }
`;

const FieldValueParentFieldsFragment = gql`
  fragment FieldValueParentFields on FieldValueParent {
    key
  }
`;

const ParentFieldValueFieldsFragment = gql`
  fragment ParentFieldValueFields on ParentFieldValue {
    refreshable
    valueParent {
      ...FieldValueParentFields
    }
  }
  ${FieldValueParentFieldsFragment}
`;

export const FieldFieldsFragment = gql`
  fragment FieldFields on Field {
    key
    name
    type
    pfv {
      ...ParentFieldValueFields
    }
    bucketKinds
    valueHint
    description
    relOps {
      ...RelationalOperatorFields
    }
    searchable
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    nestedFieldMetadata {
      ...NestedFieldMetadataFields
    }
    isGeo
    tableNames
    isFactField
  }
  ${RelationalOperatorFragment}
  ${EntityCategoryFragment}
  ${NestedFieldMetadataFields}
  ${ParentFieldValueFieldsFragment}
`;

export const HardCodedDerivedFieldMetaFieldsFragment = gql`
  fragment HardCodedDerivedFieldMetaFields on HardCodedDerivedFieldMeta {
    description
  }
`;

export const RawSqlDerivedFieldMetaFieldsFragment = gql`
  fragment RawSqlDerivedFieldMetaFields on RawSqlDerivedFieldMeta {
    rawSql
    fullDataRequired
  }
`;

export const DictionaryFieldFieldsFragment = gql`
  fragment DictionaryFieldFields on Field {
    key
    column
    type
    name
    description
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    nestedFieldMetadata {
      ...NestedFieldMetadataFields
    }
    tableNames
    derivedDefinition {
      ... on HardCodedDerivedFieldMeta {
        ...HardCodedDerivedFieldMetaFields
      }
      ... on RawSqlDerivedFieldMeta {
        ...RawSqlDerivedFieldMetaFields
      }
    }
  }
  ${EntityCategoryFragment}
  ${NestedFieldMetadataFields}
  ${HardCodedDerivedFieldMetaFieldsFragment}
  ${RawSqlDerivedFieldMetaFieldsFragment}
`;
